import {
  CalendarOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  MessageOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import type { ReactNode } from 'react';
import './index.scss';

type MetricPlaceholder = {
  label: string;
  value: string;
  detail: string;
};

type RegionPlaceholder = {
  title: string;
  icon: ReactNode;
  items: string[];
};

const metricPlaceholders: MetricPlaceholder[] = [
  {
    label: 'Active service load',
    value: '-',
    detail: 'Service metrics',
  },
  {
    label: 'Open follow-ups',
    value: '-',
    detail: 'Follow-ups',
  },
  {
    label: 'Recent client contacts',
    value: '-',
    detail: 'Recent touchpoints',
  },
  {
    label: 'Needs attention',
    value: '-',
    detail: 'Attention summary',
  },
];

const regionPlaceholders: RegionPlaceholder[] = [
  {
    title: 'Follow-ups',
    icon: <CheckCircleOutlined />,
    items: ['No follow-ups yet', 'Client owner', 'Target date'],
  },
  {
    title: 'Recent touchpoints',
    icon: <MessageOutlined />,
    items: ['No touchpoints yet', 'Client', 'Last contact'],
  },
  {
    title: 'Upcoming meetings',
    icon: <CalendarOutlined />,
    items: ['No meetings yet', 'Client', 'Meeting time'],
  },
  {
    title: 'Attention summary',
    icon: <WarningOutlined />,
    items: ['No attention items yet', 'Priority', 'Status'],
  },
];

const AdvisorPrepDashboard = () => {
  return (
    <main className="advisor-prep-dashboard" aria-labelledby="advisor-prep-dashboard-title">
      <section
        className="advisor-prep-dashboard__header"
        aria-label="Advisor Prep Dashboard overview"
      >
        <div>
          <p className="advisor-prep-dashboard__eyebrow">Advisor prep workspace</p>
          <h1 id="advisor-prep-dashboard-title">Advisor Prep Dashboard</h1>
        </div>
        <div className="advisor-prep-dashboard__status" role="status">
          <ClockCircleOutlined />
          <span>Placeholder shell</span>
        </div>
      </section>

      <section className="advisor-prep-dashboard__metrics" aria-label="Service metrics">
        {metricPlaceholders.map((metric) => (
          <article className="advisor-prep-dashboard__metric" key={metric.label}>
            <span>{metric.detail}</span>
            <strong>{metric.value}</strong>
            <p>{metric.label}</p>
          </article>
        ))}
      </section>

      <section className="advisor-prep-dashboard__regions" aria-label="Dashboard regions">
        {regionPlaceholders.map((region) => (
          <article className="advisor-prep-dashboard__region" key={region.title}>
            <div className="advisor-prep-dashboard__region-heading">
              <span className="advisor-prep-dashboard__region-icon" aria-hidden="true">
                {region.icon}
              </span>
              <h2>{region.title}</h2>
            </div>
            <div className="advisor-prep-dashboard__placeholder-list">
              {region.items.map((item) => (
                <div className="advisor-prep-dashboard__placeholder-row" key={item}>
                  <span>{item}</span>
                  <i aria-hidden="true" />
                </div>
              ))}
            </div>
          </article>
        ))}
      </section>
    </main>
  );
};

export default AdvisorPrepDashboard;
